import { useEffect, type PropsWithChildren } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setApiTokenProvider } from '@/lib/api';

export function ApiAuthProvider({ children }: PropsWithChildren) {
  const { getToken } = useAuth();

  useEffect(() => {
    setApiTokenProvider(async () => {
      try {
        return await getToken();
      } catch {
        return null;
      }
    });

    return () => {
      setApiTokenProvider(undefined);
    };
  }, [getToken]);

  return children;
}
